<template>
    <v-dialog value="true" fullscreen hide-overlay persistent>
        <v-card tile color="#fff">
          <cabecalho-pagina :ehALei14_133="true" :deveMostrarTempoRandomico="false"/>
          <v-card-text class="area-conteudo">
                <h2 class="area-conteudo__titulo">Inclusão de Proposta Manual</h2>
                <v-container color="#fff">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-flex class="area-conteudo__linha">
                                <v-flex class="passos" md8 sm12 offset-md2>
                                    <v-stepper alt-labels v-model="passoAtual">
                                        <v-stepper-header>
                                            <template v-for="(passo, index) in passos">
                                                <v-divider v-if="index" :key="`${passo.id}-divider`" class="mt-5"></v-divider>
                                                <v-stepper-step
                                                    :key="`${passo.id}-step`"
                                                    :complete="passoAtual > passo.numero"
                                                    :step="passo.numero"
                                                    @click="irParaRota(passo)"
                                                >
                                                    {{ passo.titulo }}
                                                </v-stepper-step>
                                            </template>
                                        </v-stepper-header>
                                    </v-stepper>
                                </v-flex>

                                <v-flex class="status" md2>
                                    <p class="mb-0">
                                        <strong>Situação</strong><br>
                                        <span>Em andamento</span>
                                    </p>
                                </v-flex>
                            </v-flex>

                            <v-stepper v-model="passoAtual" class="mb-5">
                                <v-stepper-items>
                                    <v-stepper-content :step="passoAtual">
                                        <transition name="fade" mode="out-in">
                                            <router-view/>
                                        </transition>
                                    </v-stepper-content>
                                </v-stepper-items>
                            </v-stepper>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import CabecalhoPagina from '@/views/pages/comprador/commons/cabecalho-pagina/CabecalhoPagina'

export default {
    name: 'EtapasIncluirProposta',
    components: {
        CabecalhoPagina,
    },
    data() {
        return {
            passoAtual: 1,
            passos: [
                { id: 0, numero: 1, titulo: 'Termos', nomeRota: 'CompradorIncluirPropostaManualTermo' },
                { id: 1, numero: 2, titulo: 'Proposta', nomeRota: 'CompradorIncluirPropostaManualProposta' }
            ]
        }
    },
    created() {
        this.definirPassoAtualPelaRota()
    },
    watch: {
        $route() {
            this.definirPassoAtualPelaRota()
        }
    },
    methods: {
        irParaRota(passo) {
            const id = this.$route.params.id
            this.$router.push({ name: passo.nomeRota, params: { id } })
        },
        definirPassoAtualPelaRota() {
            const nome = this.$route.name
            if (nome === 'CompradorIncluirPropostaManualTermo') this.passoAtual = 1
            if (nome === 'CompradorIncluirPropostaManualProposta') this.passoAtual = 2
        }
    }
}
</script>

<style scoped lang="stylus">
    .area-conteudo
        padding 0
        margin 0
        overflow-y auto
        padding-top 64px

        .container
            background-color #fff

        .list-loader
            height 200px
            margin-left 10%

        &__titulo
            margin 20px auto
            padding-bottom 20px
            text-align center
            text-transform uppercase
            color #777
            font-size 20px
            border-bottom 1px solid #e9e9e9

        &__linha
           display flex
           justify-content space-between
           align-items center
           padding 0 30px


           .status
              text-align right

    @-webkit-keyframes pulse
        to
            -webkit-transform: scale(1.1)
            transform: scale(1.1)

    @keyframes pulse
        to
            -webkit-transform: scale(1.1)
            transform: scale(1.1)

    .pulse
        display inline-block
        vertical-align middle
        -webkit-transform perspective(1px) translateZ(0)
        transform perspective(1px) translateZ(0)
        box-shadow 0 0 1px transparent
        animation pulse .8s linear infinite alternate

    @media (max-width 1900px)
        .area-conteudo__linha .passos .v-stepper__header
             &:after, &:before
                width 80px

            &:before
                left 125px

            &:after
                right 125px

    @media (max-width 1265px)
        .area-conteudo__linha .passos .v-stepper__header
            &:after, &:before
                width 60px

            &:before
                left 100px

            &:after
                right 100px

    @media (max-width 960px)
        .area-conteudo
           padding-top 48px

    @media (max-width 880px)
        .area-conteudo__linha .passos .v-stepper__header
            &:before
              left 110px

            &:after
              right 110px

    @media (max-width 768px)
        .area-conteudo__linha
            flex-direction column
            text-align center
            padding 0 20px

            .relogio, .passos
                margin-bottom 1.5rem

           .passos
               width 100%
               text-align center !important

    @media (max-width 500px)
        .area-conteudo
            &__linha
               padding 0 10px

            .v-stepper__content
                padding 10px

    @media (max-width 480px)
        .area-conteudo__linha .passos .v-stepper__header
            &:after, &:before
               display none

    @media only screen and (min-width 960px)
        .area-conteudo .container
            max-width 1200px
</style>